import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { useParams } from 'react-router';
import buskwarehousedetail from '../services/buskwarehousedetail';
// import busksellerdetail from "../services/busksellerdetail";

interface Props {
  totalProduct: number;
  selectedLogisticProduct: React.Key[];
}

const LogisticCenter = ({ totalProduct, selectedLogisticProduct }: Props) => {
  const { id } = useParams<{ id: string }>();

  const handleOnExport = async () => {
    if (selectedLogisticProduct.length > 0) {
      const response =
        await buskwarehousedetail.exportWarehouseExcellProductById(
          id,
          selectedLogisticProduct
        );
      const outputFilename = `Product_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await buskwarehousedetail.exportWarehouseExcellProduct(
        id
      );

      const outputFilename = `Product_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 상품 {totalProduct}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 상품 {selectedLogisticProduct.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default LogisticCenter;
